import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MenucontentService {
  private menuMassStart = new BehaviorSubject([]);
  currentmenuMassStart = this.menuMassStart.asObservable();

  private menuIndividualStart = new BehaviorSubject(false);
  currentmenuIndividualStart = this.menuIndividualStart.asObservable();

  private menuCheckpoints = new BehaviorSubject([]);
  currentmenuCheckpoints = this.menuCheckpoints.asObservable();

  constructor() {}

  changeMenuMassStart() {
    var mass_start_array = this.menu_get_mass_starts();
    this.menuMassStart.next(mass_start_array);
  }

  changeMenuIndividualStart() {
    var has_individual_start= this.menu_get_individual_starts() ;
    this.menuIndividualStart.next(has_individual_start);
  }

  changeCheckpoints() {
    var checkpoint_array = this.menu_get_checkpoints() ;
    this.menuCheckpoints.next(checkpoint_array);
  }

   // Get all the mass starts
  menu_get_mass_starts() {
    var events_json = localStorage.getItem('global_menu_json');

    if (events_json == '' || events_json == null) {
      return;
    }
    
    var mass_start_array = [];

    var jsonObject = JSON.parse(events_json);

    for (var a = 0; a < jsonObject.length; a++) {
      var jsonTimingPoint = jsonObject[a].timing_point;

      // Check the amount of stages that has a mass start
      var mass_start_count = 0;
      for (var b = 0; b < jsonTimingPoint.length; b++) {
        if (jsonTimingPoint[b].type.includes('One Starting Group')) {
          mass_start_count++;
        }
      }

      for (var b = 0; b < jsonTimingPoint.length; b++) {
        if (jsonTimingPoint[b].type.includes('One Starting Group')) {
          if (mass_start_count > 1) {
            mass_start_array[jsonTimingPoint[b].id] =
              jsonObject[a].event_name +
              ' - ' +
              'Stage ' +
              jsonTimingPoint[b].stage;
          } else {
            mass_start_array[jsonTimingPoint[b].id] = jsonObject[a].event_name;
          }
        }
      }
    }

    return mass_start_array;
  }

  // Check if there are any individual starts
  menu_get_individual_starts() {
    var events_json = localStorage.getItem('global_menu_json');

    if (events_json == '' || events_json == null) {
      return;
    }

    var has_individual_start = false;

    var jsonObject = JSON.parse(events_json);

    for (var a = 0; a < jsonObject.length; a++) {
      var jsonTimingPoint = jsonObject[a].timing_point;
      for (var b = 0; b < jsonTimingPoint.length; b++) {
        if (jsonTimingPoint[b].type.includes('Individually Timed')) {
          has_individual_start = true;
        }
      }
    }

    return has_individual_start;
  }

  // Get all the checkpoints that needs scanning
  // https://stackoverflow.com/questions/15268594/iterate-through-nested-json-object-array
  menu_get_checkpoints() {
    var events_json = localStorage.getItem('global_menu_json');

    if (events_json == '' || events_json == null) {
      return;
    }

    var checkpoint_array = [];

    var jsonObject = JSON.parse(events_json);

    for (var a = 0; a < jsonObject.length; a++) {
      var jsonTimingPoint = jsonObject[a].timing_point;

      for (var b = 0; b < jsonTimingPoint.length; b++) {
        //console.log(jsonTimingPoint[b].type);
        if (
          !checkpoint_array.includes(jsonTimingPoint[b].type) &&
          jsonTimingPoint[b].type.includes('Checkpoint ')
        ) {
          checkpoint_array.push(jsonTimingPoint[b].type);
        }
      }
    }
    return checkpoint_array;

  }
}
